export enum AccountManagementPermissions {
  FULL = "FULL",
  ACTION = "ACTION"
}